export default function selectSelectedValue (selector$) {
  const selectedOption = selector$.find('option:selected').expectLength()
  return selectedOption.val()
}
